export default __webpack_public_path__ + "static/media/Acolyte's Boots of the Eighteen Pits.234feaf5.jpg";